import actions from './actions'

const initialState = {
  orderID: '',
  paymentID: '',
  receivedPaymentID: '',
  signature: '',
  postpaymentloading: false,
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
